/* istanbul ignore file */
// @ts-check
import {
  BreakdownIllustration,
  HolyGrailIllustration,
  PulseIllustration
} from '@linearb/linui-common';
import {
  CALL_TO_ACTION_SLIDES_TEXTS,
  TRACKING
} from '../dashboard.doraV2.freeTier.consts';
import { TRACKING as TRACKING_EVENTS } from 'common/constants/constants';
import history from 'common/RouterHistory';
import * as TrackingService from 'common/services/tracking.service';
import AppRouter from 'common/AppRouter';
import { EMPTY_DUMMY_ORG_LEVEL_TEAM_GOALS_DASHBOARD } from 'views/root/views/home/views/performance/views/CustomReport/consts';

const navigateSlideWithAmplitude = ({ slide, action }) => {
  TrackingService.logEvent(TRACKING.EVENTS.CTA_CLICK, {
    page: TRACKING_EVENTS.PAGES.DASHBOARD,
    cta: TRACKING.CTA_TYPE.CAROUSEL,
    cta_slide: slide,
    intent: TRACKING.CTA_INTENT.DASHBOARD_CAROUSEL,
    source_url: window.location.href
  });
  action();
};

export const callToActionSlides = ({ showCta }) => [
  {
    header: CALL_TO_ACTION_SLIDES_TEXTS.CARD_HEADER_GOALS,
    text: CALL_TO_ACTION_SLIDES_TEXTS.CARD_TEXT_GOALS,
    buttonLabel: CALL_TO_ACTION_SLIDES_TEXTS.GET_STARTED,
    illustration: <HolyGrailIllustration />,
    onClick: () =>
      navigateSlideWithAmplitude({
        slide: TRACKING.CTA_SLIDES.GOALS_REPORTING,
        action: () =>
          history.push(
            showCta
              ? AppRouter.TEAMS_CTA.path
              : `${AppRouter.TEAM_GOALS.path}/${EMPTY_DUMMY_ORG_LEVEL_TEAM_GOALS_DASHBOARD.id}`
          )
      })
  },
  {
    header: CALL_TO_ACTION_SLIDES_TEXTS.CARD_HEADER_RESOURCE_ALLOCATION,
    text: CALL_TO_ACTION_SLIDES_TEXTS.CARD_TEXT_RESOURCE_ALLOCATION,
    buttonLabel: CALL_TO_ACTION_SLIDES_TEXTS.GET_STARTED,
    illustration: <BreakdownIllustration />,
    onClick: () =>
      navigateSlideWithAmplitude({
        slide: TRACKING.CTA_SLIDES.RESOURCE_ALLOCATION,
        action: () =>
          history.push(AppRouter.PROJECTS_RESOURCE_ALLOCATION_OVERVIEW.path)
      })
  },
  {
    header: CALL_TO_ACTION_SLIDES_TEXTS.CARD_HEADER_PROJECT_DELIVERY,
    text: CALL_TO_ACTION_SLIDES_TEXTS.CARD_TEXT_PROJECT_DELIVERY,
    buttonLabel: CALL_TO_ACTION_SLIDES_TEXTS.GET_STARTED,
    illustration: <PulseIllustration />,
    onClick: () =>
      navigateSlideWithAmplitude({
        slide: TRACKING.CTA_SLIDES.PREDICTABLE_PAGE_DELIVERY,
        action: () => history.push(AppRouter.PROJECTS_API.path)
      })
  }
];
